import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSearchParams } from 'src/utils/useSearchParams';
import { postConfirmEmailAPI } from 'src/serverApi/account';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import routes from 'src/constants/routes';
import SBPLogo from 'src/components/SBPLogo';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import ContentLayout from 'src/components/ContentLayout';
import styles from './styles.module.scss';

const EmailConfirmation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const withAuthorities = useWithAuthorities([]);
  
  const [isConfirmed, setIsConfirmed] = useState(false);

  const confirmEmail = async () => {
    try {
      await withAuthorities(async () => {
        await postConfirmEmailAPI(searchParams.get('confirmation') || '');
        setIsConfirmed(true);
      });
    } catch (error) {
      const { type } = error as any;
      const messages: { [key: string]: string } = {
        ['USER_EMAIL_NOT_SPECIFIED']: 'Ошибка подтверждения. Электронная почта не указана.',
        ['EMAIL_ALREADY_CONFIRMED']: 'Электронная почта уже подтверждена.',
        ['MAX_ATTEMPTS_EXCEEDED']: 'Превышено количество попыток подтверждения в сутки.',
        ['EMAIL_CONFIRMATION_EXPIRED']: 'Ссылка недействительна. Получите новую ссылку и перейдите по ней.',
        ['INVALID_EMAIL_CONFIRMATION_STRING']: 'Ссылка недействительна. Получите новую ссылку и перейдите по ней.',
        ['NOT_FOUND']: 'Ссылка недействительна. Получите новую ссылку и перейдите по ней.',
      };
      toast.error(messages[type] || 'Произошла ошибка. Попробуйте позже.');
    }
  };

  useEffect(() => {
    confirmEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContentLayout size="small">
      <SBPLogo className={styles['sbp-logo']} />
      <Text type="h2" className={styles['title']}>Подтверждение почты</Text>
      {isConfirmed && (
        <>
          <Text type="p" muted className={styles['text']}>
            Почта подтверждена.{' '}
          </Text>
          <Link key={routes.accountProfile} to={routes.accountProfile} className={styles['link']}>Перейти в профиль</Link>
        </>
      )}
      {!isConfirmed && (
        <Text type="p" muted className={styles['text']}>Происходит подтверждение почты. Пожалуйста, подождите.</Text>
      )}
    </ContentLayout>
  );
};

export default EmailConfirmation;
